import { render, staticRenderFns } from "./order-status-update.vue?vue&type=template&id=03056f0c&scoped=true"
import script from "./order-status-update.vue?vue&type=script&lang=js"
export * from "./order-status-update.vue?vue&type=script&lang=js"
import style0 from "./order-status-update.vue?vue&type=style&index=0&id=03056f0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03056f0c",
  null
  
)

export default component.exports